import React from "react";

const SponsorsComponent = ({ sponsors, strapiBaseUrl }) => {
  if (!Array.isArray(sponsors) || sponsors.length === 0) return null;

  return (
    <div className="container mt-10 mb-10">
      <h3 className="text-primary mb-4">Sponsors</h3>
      <div className="row g-4">
        {sponsors.map((sponsor) => {
          const logoUrl = sponsor.logo?.[0]?.url
            ? `${strapiBaseUrl}${sponsor.logo[0].url}`
            : null;

          return (
            <div key={sponsor.id} className="col-6 col-md-3 text-center">
              {logoUrl && (
                <a href={sponsor.url} target="_blank" rel="noopener noreferrer">
                  <img
                    src={logoUrl}
                    alt={sponsor.name}
                    className="img-fluid mb-2"
                    style={{ maxHeight: "100px", objectFit: "contain" }}
                  />
                </a>
              )}
              <p className="text-black mb-0" style={{ fontWeight: "bold" }}>
                {sponsor.name}
              </p>
              <small className="text-muted">{sponsor.type}</small>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SponsorsComponent;
